import $ from 'jquery';
import Sortable from 'sortablejs';
import csrfToken from '../fn/csrfToken';

const updateList = () => {
  // document.querySelector('.sortables-updater').click();
};

const init = () => {
  const el = document.querySelector('.sortables');
  if (!el) return;

  const sortable = Sortable.create(el, {
    onEnd: function (evt) {
      const payload = {
        method: 'PATCH',
        body: JSON.stringify({ course_cmodule: { position_position: evt.newIndex } }),
        credentials: 'same-origin',
        headers: new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken(),
          'X-Requested-With': 'XMLHttpRequest',
        }),
      };

      fetch(`/course_cmodules/${evt.item.getAttribute('data-id')}`, payload)
        .then(response => response.json())
        .then(json => updateList())
        .catch(error => console.error(error));
    },
  });
};

const start = () => {
  document.addEventListener('page:load', init);
  // document.addEventListener('ajax:success', init);
};

export default { start };
